import { useTranslation } from 'react-i18next';
import { QueryKeys } from '@connect-x-app/shared-domain-models';
import { updateQuickReply } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateQuickReplies = () => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: updateQuickReply,
    mutationKey: [QueryKeys.QUICK_REPLIES],
    onError: () => toastError(t('TOAST_ERROR')),
    onSuccess: () => {
      toastSuccess(t('TOAST_SUCCESS'));
      return queryClient.invalidateQueries({ queryKey: [QueryKeys.QUICK_REPLIES] });
    },
  });

  return { isPending, updateQuickReply: mutateAsync };
};
